import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { AuthorizeLoginTotp, goToNextAuthStep } from "../../actions/auth";
import { ROUTES } from "../../constants/clientRoutes";
import { PAGES, COMMON } from "../../constants/localization";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import { useAppDispatch } from "../../store/hooks";
import { toErrorObjs } from "../../services/formatter";

// types
import type { ErrorObj } from "../../types/errors";
import type { TOTPFormValues } from "../../types/components/TOTP";

// ui components
import AuthLayout from "../../components/Layouts/AuthLayout";
import TOTPCard from "../../components/Login/TOTPCard";
import Modal from "../../components/Common/Modal";

const TOTP = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [submitting, setSubmitting] = useState(false);
  const [resetValues, setResetValues] = useState(false);
  const [errors, setErrors] = useState<ErrorObj[] | null>(null);
  const [showCannotGetCodeModal, setShowCannotGetCodeModal] = useState(false);

  const onSubmit = useCallback(
    async (values: TOTPFormValues): Promise<void> => {
      setSubmitting(true);
      setErrors(null);
      setResetValues(false);

      try {
        // TODO: remove casts when actions/auth.js is converted to TS
        await dispatch((AuthorizeLoginTotp as any)(values));
        dispatch((goToNextAuthStep as any)(history));
      } catch (error: unknown) {
        setSubmitting(false);
        setErrors(toErrorObjs(error));
        setResetValues(true);
      }
    },
    [dispatch, history]
  );

  return (
    <AuthLayout backActionRoute={ROUTES.AUTH.LOGIN}>
      <TOTPCard
        onSubmit={onSubmit}
        errors={errors}
        resetValues={resetValues}
        submitting={submitting}
        onCannotGetCode={() => setShowCannotGetCodeModal(true)}
      />

      <Modal
        open={showCannotGetCodeModal}
        onClose={() => setShowCannotGetCodeModal(false)}
        title={PAGES.AUTH.TOTP.CANNOT_GET_CODE}
        content={<p>{PAGES.AUTH.TOTP.CONTACT_SUPPORT}</p>}
        actions={[
          {
            title: COMMON.CLOSE,
            onClick: () => setShowCannotGetCodeModal(false),
            displayType: ACTION_DISPLAY_TYPES.SECONDARY,
            focused: true,
          },
          {
            title: PAGES.SUPPORT.CONTACT_SUPPORT,
            onClick: () => (location.href = ROUTES.EXTERNAL.SUPPORT),
            displayType: ACTION_DISPLAY_TYPES.PRIMARY,
          },
        ]}
      />
    </AuthLayout>
  );
};

export default TOTP;